window.jQuery = window.$ = require('jquery');
window.moment = require('moment');
window.moment.updateLocale('en', {
    monthsShort: [
        'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.',
        'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'
    ]
});

window._ = require('lodash');
window.s = require('underscore.string');
window.sprintf = require('sprintf-js').sprintf;
window.Backbone = require('backbone');
window.Marionette = require('backbone.marionette');
window.Marionette.TemplateCache.prototype.compileTemplate = function (rawTemplate, options) {
    return window._.template(rawTemplate, options);
};
require('bootstrap');
require('velocity-animate');
